export const TAB_KEYS = Object.freeze({
  salespeople: 'salespeople',
  colleagues: 'colleagues',
  topSuggestions: 'top_suggestions',
} as const);
